/* /sin-salida-de-humos/ - hero background video (Planika projects footage) + 3D scroll effects for the rest of the page. */

const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;

/* ------------------------------------------------------------------ hero background video */
function hero() {
  const v = document.querySelector("[data-herovideo]");
  if (!v) return;
  if (reduce) return;                       // poster only
  v.src = matchMedia("(max-width: 760px)").matches ? v.dataset.srcM : v.dataset.srcD;
  v.muted = true; v.preload = "auto";
  const p = v.play(); if (p && p.catch) p.catch(() => {});
  new IntersectionObserver(es => { es[0].isIntersecting ? v.play().catch(() => {}) : v.pause(); }).observe(v);
}

/* ------------------------------------------------------------------ 3D scroll effects */
function reveals() {
  const els = document.querySelectorAll("[data-r3d]");
  if (reduce || !("IntersectionObserver" in window)) { els.forEach(e => e.classList.add("in")); return; }
  const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } }), { rootMargin: "0px 0px -10% 0px" });
  els.forEach((e, i) => { e.style.setProperty("--d", (e.dataset.r3dDelay || 0) + "ms"); io.observe(e); });
}

function coverflow() {
  const wrap = document.querySelector("[data-cover3d]");
  if (!wrap || reduce) return;
  const items = [...wrap.children];
  const upd = () => {
    const r = wrap.getBoundingClientRect(), k = (innerHeight / 2 - (r.top + r.height / 2)) / innerHeight; // -1..1
    items.forEach((el, i) => {
      const o = i - (items.length - 1) / 2;
      el.style.transform = `translateZ(${-Math.abs(o) * 60 + k * 40}px) rotateY(${o * -10 + k * 24}deg) rotateX(${k * -6}deg)`;
    });
  };
  addEventListener("scroll", upd, { passive: true }); upd();
}

function counters() {
  document.querySelectorAll("[data-count]").forEach(el => {
    const end = parseFloat(el.dataset.count), suf = el.dataset.suf || "", pre = el.dataset.pre || "";
    const fmt = v => pre + String(Math.round(v)).replace(/\B(?=(\d{3})+(?!\d))/g, ".") + suf;
    if (reduce) { el.textContent = fmt(end); return; }
    el.textContent = fmt(0);
    new IntersectionObserver((es, o) => {
      if (!es[0].isIntersecting) return; o.disconnect();
      const t0 = performance.now(), d = 1400;
      (function f(now) { const p = Math.min(1, (now - t0) / d); el.textContent = fmt(end * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(f); })(t0);
    }).observe(el);
  });
}

function depth() {
  /* the story heading and the form card float on scroll */
  if (reduce) return;
  const els = document.querySelectorAll("[data-depth]");
  const upd = () => els.forEach(el => {
    const r = el.getBoundingClientRect(), k = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
    el.style.transform = `perspective(1000px) rotateX(${k * 10}deg) translateZ(${-Math.abs(k) * 60}px)`;
  });
  addEventListener("scroll", upd, { passive: true }); upd();
}

hero(); reveals(); coverflow(); counters(); depth();
